import { render, staticRenderFns } from "./BlockNewCustomer.vue?vue&type=template&id=c5336fc6&scoped=true&"
import script from "./BlockNewCustomer.vue?vue&type=script&lang=js&"
export * from "./BlockNewCustomer.vue?vue&type=script&lang=js&"
import style0 from "./BlockNewCustomer.vue?vue&type=style&index=0&id=c5336fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5336fc6",
  null
  
)

export default component.exports